import { getFetch } from '../fetch';
import { apiConfig } from '../config';

export function getClessonCertificates(clessonId: number): Promise<Record<number, string>> {
    const { apiGetCLessonCertificates } = apiConfig.getStaticUrls();

    return getFetch(`${apiGetCLessonCertificates}${clessonId}/`);
}
